
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","transform":"translate(4 3)"}},[_c('path',{attrs:{"d":"M13.75 1H14a2 2 0 012 2v13a2 2 0 01-2 2H2a2 2 0 01-2-2V3a2 2 0 012-2h.25"}}),_c('rect',{attrs:{"width":"6","height":"3","x":"5","rx":"1"}}),_c('path',{attrs:{"d":"M5 8.5h6m-6 4h6"}})])])
          )
        }
      }
    